import { createAction } from 'redux-actions';
import { createRoutine } from 'redux-saga-routines';
import { LIST_REGION, RETRIEVE_REGION, SET_REGION } from './type';

export const listRegions = createRoutine(LIST_REGION);
export const retrieveRegion = createRoutine(RETRIEVE_REGION);

export const setRegion = createAction(SET_REGION);
